// src/utils/platform.js
import { Capacitor } from '@capacitor/core';

export const isElectron = typeof window !== 'undefined' && window.isElectron;
export const isCapacitor = Capacitor.isNativePlatform();
export const isNative = isElectron || isCapacitor;
export const isAndroid = Capacitor.getPlatform() === 'android';
export const isIOS = Capacitor.getPlatform() === 'ios';

/**
 * Determines the default post-login navigation destination based on platform
 * @returns {string} The route path to navigate to after successful login
 */
export function getPostLoginDestination() {
  if (isCapacitor) return "/recorder";
  if (isElectron) return "/reports";
  return "/home";
}